function stickyrefine() {
  	var fixedPadding = 20;
  	if ($(window).width() > 1240) {
		var refineOffset = $('#product-wrap').offset().top - $('#header').outerHeight() - (fixedPadding * 3);
    } else {
		var refineOffset = $('#product-wrap').offset().top - $('#header').outerHeight() - ($('.refine-Mobile').outerHeight()*0.9) - (fixedPadding * 2);
    };  	 	
    var limitHeight = $('#mainWrapper').outerHeight() - $('#product-wrap').offset().top + refineOffset;
    var fixPosition = $('#header').outerHeight() + fixedPadding;  	
  function fixit() {
      if (!$('.refine-Mobile').hasClass('mm-fixed-top')){
        $('.refine-Mobile').addClass('mm-fixed-top');        
        $('.refine-Mobile').css('position', 'fixed'); 
      }
      if ($('.refine-Mobile').css('top') != fixPosition) {$('.refine-Mobile').css('top', fixPosition);};
      if (!$('#mainWrapper').hasClass('fixed-filter-menu')){
          $('#mainWrapper').addClass('fixed-filter-menu');
      }
    };
    function unfixit() {
       if ($('.refine-Mobile').hasClass('mm-fixed-top')){
         $('.refine-Mobile').removeClass('mm-fixed-top');         
         $('.refine-Mobile').css('position', '');
         $('.refine-Mobile').css('top', '');
       }      
       if ($('#mainWrapper').hasClass('fixed-filter-menu')){
          $('#mainWrapper').removeClass('fixed-filter-menu');
       }
    };  
  if ($(window).height() > 360) {    
    if (refineOffset <= $(window).scrollTop() && $(window).scrollTop() < limitHeight) {fixit();} else {unfixit();}
  } else {
  	unfixit();
  };  
  //$('.jor-test').text(refineHeight);  
    var $el = $('#mainWrapper'),
        scrollTop = $(this).scrollTop(),
        scrollBot = scrollTop + $(this).height(),
        elTop = $el.offset().top,
        elBottom = elTop + $el.outerHeight(),
        visibleTop = elTop < scrollTop ? scrollTop : elTop,
        visibleBottom = elBottom > scrollBot ? scrollBot : elBottom,
        refineMaxHeight = 300,
        refineHeight = visibleBottom - visibleTop - 175;
  if (refineHeight <= refineMaxHeight && $('#mainWrapper').hasClass('fixed-filter-menu') && refineHeight != $('.desktop-refinemenu-hide .collection-side-bar').height()) {    
    $('.desktop-refinemenu-hide .collection-side-bar').css("height",refineHeight);
    if ($('.desktop-refinemenu-hide .collection-side-bar').height() == 0){
      if ($('.desktop-refinemenu-hide .collection-side-bar').is(":visible")){$('.desktop-refinemenu-hide .collection-side-bar').hide();};}
    else {
      if ($('.desktop-refinemenu-hide .collection-side-bar').is(":hidden")){$('.desktop-refinemenu-hide .collection-side-bar').show();};
    };    
  } else if (refineHeight > refineMaxHeight && $('#mainWrapper').hasClass('fixed-filter-menu') && refineHeight != $('.desktop-refinemenu-hide .collection-side-bar').height()) {    
  	$('.desktop-refinemenu-hide .collection-side-bar').css("height",refineHeight);    
  } else if (!$('#mainWrapper').hasClass('fixed-filter-menu')) {
    if ($('.desktop-refinemenu-hide .collection-side-bar').height() > 0){$('.desktop-refinemenu-hide .collection-side-bar').css("height","");};
    if ($('.desktop-refinemenu-hide .collection-side-bar').is(":hidden")){$('.desktop-refinemenu-hide .collection-side-bar').show();};
  };
};
$(window).on('scroll resize', stickyrefine);
